import { render } from "./OptionCarQR.vue?vue&type=template&id=2b71aa68"
import script from "./OptionCarQR.vue?vue&type=script&lang=js"
export * from "./OptionCarQR.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/OptionCarQR.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b71aa68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b71aa68', __exports__)) {
    api.reload('2b71aa68', __exports__)
  }
  
  module.hot.accept("./OptionCarQR.vue?vue&type=template&id=2b71aa68", () => {
    api.rerender('2b71aa68', render)
  })

}


export default __exports__